import { css } from "@emotion/react";

import theme from "../../styles/theme";
import { drawerWidth, white, black, blue, greyLight, greySecondary, greyDark } from "../../styles/variables";

const { palette, spacing } = theme;

export const drawer = css`
  .MuiDrawer-paperAnchorDockedLeft {
    border-right: unset;
  }
  .MuiDrawer-paper {
    width: ${drawerWidth};
    background: ${greyLight};
    display: flex;
    flex-direction: column;
  }
`;

export const logo = css`
  margin: ${spacing(3)}px 0 ${spacing(1)}px ${spacing(2)}px;
  width: 108px;
`;

export const list = css`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`;

export const menuGap = css`
  margin-top: auto;
`;

export const focusedListItem = css`
  &::before {
    content: "";
    position: absolute;
    background-color: ${blue};
    border-radius: 2px;
    width: 4px;
    height: 50%;
    top: 25%;
    left: 0;
  }
`;

export const btn = css`
  width: 100%;
  border-radius: 4px;
  color: ${black};
  .MuiTypography-body1 {
    font-weight: bold;
    font-family: SFProText, "Roboto", "Helvetica", "Arial", sans-serif;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
  }
  &.MuiButton-root.Mui-disabled {
    color: ${blue};
    opacity: 0.3;
  }

  &:hover {
    background: ${greySecondary};
  }
`;

export const btnHighlight = css`
  color: ${palette.primary.main};

  &,
  &:hover {
    background: ${white};
    box-shadow: 0 6px 16px 0 rgba(67, 94, 96, 0.1), 0 0 8px 0 rgba(0, 0, 0, 0.05);
  }
`;

export const btnFocused = css`
  &,
  &:hover {
    color: ${blue};
    background: ${greyLight};
  }
  svg {
    color: ${blue};
  }
`;

export const icon = css`
  min-width: 34px;
  color: ${black};
`;

export const iconHighlight = css`
  color: ${palette.primary.main};
`;

export const version = css`
  padding: ${spacing(1.5)}px 0;
  text-align: center;
  flex-shrink: 0;
`;

export const inputAdornment = css`
  margin-right: 10px;
`;

export const timeBlock = css`
  width: 100%;
  box-shadow: none;
  background-color: rgba(255, 255, 255, 0.8);
`;

export const timeBlockHeader = css`
  padding: ${spacing(1, 1.25)};

  .MuiCardHeader-action {
    margin: 0;
  }
`;

export const timeBlockContent = css`
  padding: ${spacing(0, 1.25, 1.25)};

  &:last-child {
    padding-bottom: ${spacing(1.25)}px;
  }
`;

export const accessTimeIcon = css`
  width: 16px;
  height: 16px;
  vertical-align: middle;
`;

export const moreBtn = css`
  padding: 0;
  font-weight: normal;
  font-size: 12px;
`;

export const timeCaption = css`
  color: ${greyDark};
`;

export const time = css`
  font-weight: bold;
  font-size: 18px;
`;

export const upgradeBtn = css`
  width: 100%;
  margin-top: ${spacing(2)}px;
`;

export const moreDetail = css`
  width: 400px;
  color: ${black};
  padding: ${spacing(0, 2.5, 5)};
`;

export const policyBtn = css`
  padding: ${spacing(1, 0)};
  font-weight: normal;
  font-size: 12px;
`;
